import React, { useState } from "react";
import { Col, Modal, Nav, Row, Tab, Image, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const InvestigatorsModuleEdit = () => 
{
    
    return (
      <>
            <a href="/InvestigatorsModuleDetails">
            <b>
              VIEW ALL
              <span style={{ fontSize: "18px" }}>{" >"}</span>
            </b>
            </a>
           
    </>
      );
    };

export default InvestigatorsModuleEdit;
